module.exports = __webpack_public_path__ + "static/media/clock.b7b46f89.svg";